import { FC } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { DialogContactsFormValues } from './types';

type Props = {
  control: Control<DialogContactsFormValues>;
  gap: number;
  errors: FieldErrors<DialogContactsFormValues>;
};

export const ContactOtherFields: FC<Props> = ({ control, gap, errors }) => {
  const t = useTranslations('core.dialogContacts');
  const { isMobile } = useBreakingPoints();

  return (
    <Box mt='s' display='flex' flexDirection='column' style={{ gap }}>
      <Typography variant='p2' color='primary/text'>
        {t('contactOther.header')}
      </Typography>
      <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} style={{ gap }}>
        <Box flex={1}>
          <Form.FormInput
            // @ts-ignore react-hook-form generic mismatch with FieldValues
            control={control}
            additonalProps={{ required: true }}
            name='firstName'
            placeholder={t('fields.firstNamePlaceholder')}
            label={t('fields.firstName')}
            autoComplete='off'
            hasError={!!errors.firstName}
          />
        </Box>
        <Box flex={1}>
          <Form.FormInput
            // @ts-ignore react-hook-form generic mismatch with FieldValues
            control={control}
            additonalProps={{ required: true }}
            name='lastName'
            placeholder={t('fields.lastNamePlaceholder')}
            label={t('fields.lastName')}
            autoComplete='off'
            hasError={!!errors.lastName}
          />
        </Box>
      </Box>
      <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} style={{ gap }}>
        <Box flex={1}>
          <Form.FormInput
            // @ts-ignore react-hook-form generic mismatch with FieldValues
            control={control}
            additonalProps={{
              required: true,
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Invalid email',
              },
            }}
            name='email'
            placeholder={t('fields.emailPlaceholder')}
            label={`${t('fields.email')}`}
            autoComplete='off'
            hasError={!!errors.email}
          />
        </Box>
        <Box flex={1}>
          <Form.FormInput
            // @ts-ignore react-hook-form generic mismatch with FieldValues
            control={control}
            additonalProps={{ required: true }}
            name='phone'
            placeholder={t('fields.phonePlaceholder')}
            label={t('fields.phone')}
            autoComplete='off'
            hasError={!!errors.phone}
          />
        </Box>
      </Box>
      <Box height={1} bg='grey/light/background' my='s' />
      <Box>
        <Form.FormTextArea
          // @ts-ignore react-hook-form generic mismatch with FieldValues
          control={control}
          name='message'
          placeholder={t('fields.messagePlaceholder')}
          label={t('fields.messageOptional')}
          labelVariant='p3/light'
          textColor='white'
          labelProps={{ mb: 'xs', color: 'grey/light' }}
          bg='primary/background'
        />
      </Box>
    </Box>
  );
};
